<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <!-- 排序方式：<el-select size="mini" style="width:100px;" clearable @change="refetchData" v-model="level" placeholder="排序方式">
                <el-option key="高优" label="高优" value="高优"></el-option>
                <el-option key="低优" label="低优" value="低优"></el-option>
            </el-select> -->
            <el-input placeholder="标题、标签、分类" size="mini" style="width: 300px;" clearable @keyup.native.enter="refetchData" prefix-icon="el-icon-search" v-model="keyword"></el-input>
            <el-button class="margin-l" size="mini" type="primary" @click.stop="refetchData">搜索</el-button>
            <el-button class="margin-l" size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
            <el-button class="margin-l" size="mini" type="danger" @click.stop="oneKeyHide()">一键切换</el-button>
        </div>

        <paged-table ref="table" class="block-mini-top" @fetch-data="fetchData">
            <el-table @sort-change="handleSort" slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column type="index" align="center" width="45"></el-table-column>
                <el-table-column label="标签" prop="tag" align="center" width="70"></el-table-column>
                <el-table-column label="分类" prop="category" align="center" width="70"></el-table-column>
                <el-table-column label="标题" prop="title" align="center" width="200"></el-table-column>
                <el-table-column label="最高预期收益" prop="expectRate" align="center" width="80"></el-table-column>
                <el-table-column label="投资期限" prop="timeLimit" align="center" width="120"></el-table-column>
                <el-table-column label="起投金额" prop="startAmount" align="center" width="80"></el-table-column>
                <el-table-column label="优先级" prop="level" align="center" width="70" sortable="custom"></el-table-column>
                <el-table-column label="基点" prop="basePoint" align="center" width="50"></el-table-column>
                <el-table-column label="上架" align="center" width="60">
                    <template slot-scope="scope">
                        <el-switch @change="doOnline(scope.row)" :width="35" v-model="scope.row.online">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" class="super-mini-button" @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" class="super-mini-button" @click.stop="removeModel(scope.row)">删除</el-button>
                        <el-button type="success" size="mini" class="super-mini-button" @click.stop="copy(scope.row)">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>
        <dialog-edit-good ref="edit" @fetch-data="fetchData"></dialog-edit-good>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";

import DialogEditGood from "../components/dialog/dialogEditGood.vue";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";

export default {
    components: {
        DialogEditGood,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            loading: false,
            level: "",
        };
    },
    created() {},
    mounted() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() {},
    methods: {
        handleSort(data) {
            let label = data.column.label;
            let order = data.order;
            if (label == "优先级") {
                if (order == "descending") {
                    this.level = "高优";
                } else if (order == "ascending") {
                    this.level = "低优";
                } else {
                    this.level = "";
                }
            }
            this.refetchData();
        },
        async oneKeyHide() {
            this.loading = true;
            for (let i = 0; i < this.data.length; i++) {
                let item = this.data[i];
                item.online = !item.online;
                await HttpClient.put("/restful", {
                    model: "Good",
                    cond: item._id,
                    updates: item,
                });
            }
            this.refetchData();
        },
        async doOnline(item) {
            this.loading = true;
            await HttpClient.put("/restful", {
                model: "Good",
                cond: item._id,
                updates: item,
            });
            msgSuccess();
            this.refetchData();
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {};
            if (this.keyword) {
                const regex = {
                    $regex: this.keyword,
                    $options: "ig",
                };
                cond["$or"] = [
                    {
                        title: regex,
                    },
                    {
                        tag: regex,
                    },
                    {
                        category: regex,
                    },
                ];
            }
            let sort = {
                _id: -1,
            };
            if (this.level) {
                if (this.level == "高优") {
                    sort = {
                        level: -1,
                    };
                } else if (this.level == "低优") {
                    sort = {
                        level: 1,
                    };
                }
            }
            this.loading = true;
            let res = await HttpClient.post("/restful", {
                model: "Good",
                cond,
                sort,
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);
            this.loading = false;
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        copy(item) {
            let newItem = JSON.parse(JSON.stringify(item));
            delete newItem._id;
            this.edit.addOrEdit(newItem);
        },
        async removeModel(item) {
            await actionConfirm();
            this.loading = true;
            await removeModel("Good", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
